import { useState } from 'react'
import { CopyIcon } from '../../../icons'

interface ClipboardProps {
  text: string
}

export const Clipboard = ({ text }: ClipboardProps) => {
  const [clicked, setClicked] = useState(false)

  function copyToClipboard() {
    navigator.clipboard.writeText(text)
    setClicked(true)
  }

  return (
    <button
      type="button"
      onClick={() => copyToClipboard()}
      className={`ap:*:text-primary ${clicked ? '' : 'ap:hover:scale-105'} ap:transition-all`}
    >
      {clicked ? <p>Kopiert!</p> : <CopyIcon />}
    </button>
  )
}
